module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types","umd":"prop-types","root":"_"}
// module id = 2
// module chunks = 0 1 2 3 4 5